import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { CSSProperties } from 'react'

import { Option } from 'types/option'

interface Props {
  options: Option[]
  onChange: (v: string) => void
  value?: string
  label?: string
  style?: CSSProperties
  disabled?: boolean
  multiple?: boolean
  required?: boolean
  fullWidth?: boolean
  onBlur?: () => void
}

export default function KanseiSimpleSelectBox(props: Props) {
  const {
    options,
    value = '',
    label = '',
    style,
    disabled = false,
    multiple = false,
    required = false,
    fullWidth = false,
    onBlur,
    onChange,
  } = props

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as string)
  }

  return (
    <FormControl fullWidth={fullWidth} size="small" sx={style}>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        required={required}
        value={value}
        label={label}
        onBlur={onBlur}
        multiple={multiple}
        disabled={disabled}
        onChange={handleChange}
      >
        {options.map((option) => {
          return (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
